import { baseThemeValues } from 'constants/common';

export const headerCellTheme = {
  bg: 'palette.surface.2',
  borderColor: 'palette.tertiary.20:0.5',
  borderWidth: '1px',
  fontFamily: baseThemeValues.inherit,
  fontSize: '14px',
  fontWeight: 500,
  mainColumnBg: 'palette.surface.3',
  text: 'palette.tertiary.60',
};
